import type { ErrorEvent, EventHint, Options } from "@sentry/core";

export function chainBeforeSend(...handlers: (Options["beforeSend"] | undefined)[]) {
  return async (event: ErrorEvent, hint: EventHint) => {
    for (const handler of handlers) {
      if (typeof handler === "function") {
        const result = await handler(event, hint);
        if (result === null) {
          return null;
        }
        event = result;
      }
    }

    return event;
  };
}
